<template>
  <div class="flex flex-col sm:flex-row items-center justify-center text-center">
    <div
      v-for="(counter, index) in counters"
      :key="index"
      class="flex flex-col flex-1 items-center justify-center text-center gap-4 last:pb-0 sm:pb-0 last:border-0 sm:border-b-0 sm:border-r px-2 sm:px-0"
    >
      <p :class="cn('text-6xl font-semibold', props.class)">
        <span>{{ counter.number }}</span>
        <span v-if="counter.unit">{{ counter.unit }}</span>
      </p>
      <p v-if="counter.description" class="max-w-3/4 text-grey-dark-300 text-[18px] leading-[25px] font-semibold">
        {{ counter.description }}
      </p>
      <Separator v-if="index < counters.length - 1" class="my-4 max-w-[168px] md:hidden" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils';
import type { HTMLAttributes } from 'vue';
import Separator from '@/components/ui/separator/SeparatorComponent.vue';

interface Counter {
  number: number;
  unit?: string;
  description?: string;
}

interface Props {
  counters: Counter[];
  class?: HTMLAttributes['class'];
}
const props = defineProps<Props>();
</script>
